export enum TestTypes {
    SANITY_TEST = 'sanity_test',
    EF_TEST = 'ef_test',
    RVT_TEST = 'rvt_test'
  }
  
  export const testTypes = Object.values(TestTypes) as string[];